module.exports = __webpack_public_path__ + "media/images/icons/icon_search_primary-0be481239f52c0397a3190beb672b62d.svg";